const PANEL_SUBTYPE_CLASS_MAP: Record<string, string> = {
  'panel-sad': 'bg-panel-sad text-panel-text-light',
  'panel-formal': 'bg-panel-formal text-panel-text-light',
  'panel-calm': 'bg-panel-calm text-panel-text-light',
  'panel-positive': 'bg-panel-positive text-panel-text-light',
  'panel-angry': 'bg-panel-angry text-panel-text-light',
  'panel-royal': 'bg-panel-royal text-panel-text-light',
  'panel-happy': 'bg-panel-happy text-panel-text-light',
  'panel-orange': 'bg-panel-orange text-panel-text-light',
  'panel-yellow': 'bg-panel-yellow text-panel-text-dark',
};

const PANEL_SUBTYPE_FALLBACK = 'bg-panel-royal text-panel-text-light';

export function panelSubtypeClasses(subType?: string): string {
  if (!subType) {
    return PANEL_SUBTYPE_FALLBACK;
  }

  return PANEL_SUBTYPE_CLASS_MAP[subType] ?? PANEL_SUBTYPE_FALLBACK;
}
